/** 予約日時の入力（カードごとに state を持つ — 従来はページ全体で1つを共有していた audit E4） */

import { useState } from 'react'
import { parseFutureJst, toJstInputValue } from '../../lib/datetime'

export function ScheduleForm({ initialIso, disabled, submitLabel = '予約する', onSubmit }: {
  initialIso?: string | null
  disabled?: boolean
  submitLabel?: string
  onSubmit: (iso: string) => void
}) {
  const [value, setValue] = useState(() => {
    if (!initialIso) return ''
    const d = new Date(initialIso)
    return Number.isNaN(d.getTime()) || d.getTime() <= Date.now() ? '' : toJstInputValue(d)
  })
  const [error, setError] = useState('')
  const min = toJstInputValue(new Date())

  const submit = () => {
    const r = parseFutureJst(value)
    if ('error' in r) { setError(r.error); return }
    setError('')
    onSubmit(r.iso)
  }

  return (
    <div className="mt-3 space-y-1">
      <p className="text-[13px] font-bold" aria-hidden>予約日時（日本時間）</p>
      <div className="flex flex-wrap items-center gap-2">
        <input type="datetime-local" value={value} min={min} aria-label="予約日時（日本時間）"
          aria-invalid={error ? true : undefined}
          onChange={e => { setValue(e.target.value); setError('') }}
          className="gm-input gm-num w-auto" />
        <button disabled={!value || disabled} onClick={submit}
          className="gm-btn gm-btn-secondary">{submitLabel}</button>
      </div>
      {error && <p role="alert" className="text-sm text-bad">{error}</p>}
    </div>
  )
}
